// Stepside theme JS

/* ===================== ULUBIONE (wishlist) ===================== */
(function(){
  var KEY='stepside_favs';
  function load(){ try{ return JSON.parse(localStorage.getItem(KEY)||'[]'); }catch(e){ return []; } }
  function save(a){ try{ localStorage.setItem(KEY, JSON.stringify(a)); }catch(e){} }
  function esc(s){ return (s||'').replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function dataOf(b){ return {h:b.dataset.h,t:b.dataset.t,v:b.dataset.v,p:b.dataset.p,from:b.dataset.from,was:b.dataset.was,img:b.dataset.img,url:b.dataset.url}; }
  var ov=document.getElementById('favOverlay'), drawer=document.getElementById('favDrawer');

  function refreshBadge(){
    var n=load().length, b=document.getElementById('favCountBadge');
    if(b){ b.textContent=n; b.hidden = n===0; }
    var hc=document.getElementById('favHeadCount'); if(hc) hc.textContent = n? String(n):'';
  }
  function syncHearts(){
    var list=load();
    document.querySelectorAll('.card-fav,.pdp-fav').forEach(function(b){
      var on=list.some(function(x){return x.h===b.dataset.h;});
      b.classList.toggle('on',on);
      var t=b.querySelector('.pf-t'); if(t) t.textContent = on? 'W ulubionych':'Dodaj do ulubionych';
    });
  }
  function toggle(btn){
    var d=dataOf(btn), list=load(), i=-1;
    for(var k=0;k<list.length;k++){ if(list[k].h===d.h){ i=k; break; } }
    if(i>-1) list.splice(i,1);
    else { list.unshift(d); btn.classList.remove('beat'); void btn.offsetWidth; btn.classList.add('beat'); }
    save(list); refreshBadge(); syncHearts(); renderDrawer();
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest && e.target.closest('.card-fav,.pdp-fav');
    if(b){ e.preventDefault(); e.stopPropagation(); toggle(b); }
  });

  function renderDrawer(){
    var body=document.getElementById('favDrBody'), empty=document.getElementById('favEmpty');
    if(!body) return;
    var list=load();
    if(!list.length){ body.innerHTML=''; if(empty) empty.hidden=false; return; }
    if(empty) empty.hidden=true;
    body.innerHTML = '<div class="fav-grid">' + list.map(function(p){
      return '<div class="fav-card">'
        + '<a class="fav-card-im" href="'+esc(p.url)+'">'+(p.img?'<img src="'+esc(p.img)+'" alt="" loading="lazy">':'')+'</a>'
        + '<button type="button" class="fav-card-rm" data-h="'+esc(p.h)+'" aria-label="Usuń z ulubionych"><svg width="15" height="15" viewBox="0 0 24 24" fill="#D6001C"><path d="M12 20s-7-4.3-7-9.3A3.7 3.7 0 0 1 12 8a3.7 3.7 0 0 1 7-1.3C19 11.7 12 20 12 20Z"/></svg></button>'
        + '<div class="fav-card-tx">'
        + '<a class="fav-card-link" href="'+esc(p.url)+'"><span class="fav-card-v">'+esc(p.v)+'</span><span class="fav-card-n">'+esc(p.t)+'</span></a>'
        + '<span class="fav-card-p">'+(p.from==='1'?'<small>od</small> ':'')+esc(p.p)+(p.was?' <span class="fav-was">'+esc(p.was)+'</span>':'')+'</span>'
        + '<a class="fav-card-add" href="'+esc(p.url)+'">Wybierz rozmiar →</a>'
        + '</div>'
        + '</div>';
    }).join('') + '</div>';
    body.querySelectorAll('.fav-card-rm').forEach(function(x){
      x.addEventListener('click',function(e){
        e.preventDefault(); e.stopPropagation();
        var l=load().filter(function(y){return y.h!==x.dataset.h;});
        save(l); refreshBadge(); syncHearts(); renderDrawer();
      });
    });
  }
  function openDrawer(){ if(!drawer) return; renderDrawer(); if(ov) ov.hidden=false; drawer.hidden=false; requestAnimationFrame(function(){ drawer.classList.add('on'); }); document.body.style.overflow='hidden'; }
  function closeDrawer(){ if(!drawer) return; drawer.classList.remove('on'); document.body.style.overflow=''; setTimeout(function(){ if(ov) ov.hidden=true; drawer.hidden=true; },300); }

  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function(){
    refreshBadge(); syncHearts();
    var o=document.getElementById('favOpen'); if(o) o.addEventListener('click',function(e){ e.preventDefault(); openDrawer(); });
    var c=document.getElementById('favDrawerClose'); if(c) c.addEventListener('click',closeDrawer);
    if(ov) ov.addEventListener('click',closeDrawer);
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeDrawer(); });
  });
})();


/* ===================== OCENY (gwiazdki) ===================== */
(function(){
  function star(on){return '<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><path d="M12 2.6l2.6 5.7 6.2.5-4.7 4.1 1.4 6.1L12 16.9 6.5 19.1l1.4-6.1L3.2 8.8l6.2-.5L12 2.6Z" fill="'+(on?'#f5a623':'#d8dadf')+'"/></svg>';}
  function stars(f){f=parseInt(f,10)||0;var h='';for(var i=1;i<=5;i++){h+=star(i<=f);}return '<span class="rt-stars">'+h+'</span>';}
  function opinie(n){var a=n%10,b=n%100;if(n===1)return 'opinia';if(a>=2&&a<=4&&(b<10||b>=20))return 'opinie';return 'opinii';}
  function fillCards(R){
    document.querySelectorAll('.card-rating[data-h]:not([data-r])').forEach(function(el){
      el.setAttribute('data-r','1');
      var d=R[el.getAttribute('data-h')];
      if(!d){el.style.display='none';return;}
      el.innerHTML=stars(d[2])+'<span class="rt-score">'+d[0]+'</span><span class="rt-count">('+d[1]+')</span>';
    });
  }
  function fillPdp(R){
    var el=document.getElementById('pdpRating'); if(!el||el.getAttribute('data-r'))return;
    el.setAttribute('data-r','1');
    var d=R[el.getAttribute('data-h')]; if(!d)return;
    el.innerHTML=stars(d[2])+'<span class="rt-score">'+d[0]+'</span><span>· '+d[1]+' '+opinie(d[1])+'</span>';
    el.hidden=false;
  }
  function run(){var R=window.STEPSIDE_RATINGS;if(!R)return false;fillCards(R);fillPdp(R);return true;}
  function boot(){ if(run())return; var t=setInterval(function(){ if(run())clearInterval(t); },80); setTimeout(function(){clearInterval(t);},6000); }
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
  if('MutationObserver' in window){var deb;var mo=new MutationObserver(function(){clearTimeout(deb);deb=setTimeout(function(){var R=window.STEPSIDE_RATINGS;if(R)fillCards(R);},150);});
    document.addEventListener('DOMContentLoaded',function(){var g=document.querySelector('main')||document.body;if(g)mo.observe(g,{childList:true,subtree:true});});}
})();
